import Playground from 'components/Playground';
import Table from "components/Table";
import * as React from 'react';
export default {
  Playground,
  Table,
  React
};